// Site access endpoints (1:1), keyed by bare site_slug:
//   GET|PUT|DELETE /api/v1/sites/{site_slug}/publication
//   GET|PUT|DELETE /api/v1/sites/{site_slug}/netbird
// Mirrors backend/src/orixen_hub/api/v1/site_access.py.

import { request, type ApiResponse } from "../client";
import type {
  NetbirdConfig,
  NetbirdIn,
  PublicationConfig,
  PublicationIn,
} from "../types/siteAccess";

const pubPath = (s: string) => `/api/v1/sites/${encodeURIComponent(s)}/publication`;
const nbPath = (s: string) => `/api/v1/sites/${encodeURIComponent(s)}/netbird`;

export const publication = {
  get: (siteSlug: string): Promise<ApiResponse<PublicationConfig>> =>
    request<PublicationConfig>("GET", pubPath(siteSlug)),
  put: (siteSlug: string, body: PublicationIn): Promise<ApiResponse<PublicationConfig>> =>
    request<PublicationConfig>("PUT", pubPath(siteSlug), body),
  remove: (siteSlug: string): Promise<ApiResponse<void>> =>
    request<void>("DELETE", pubPath(siteSlug)),
};

export const netbird = {
  get: (siteSlug: string): Promise<ApiResponse<NetbirdConfig>> =>
    request<NetbirdConfig>("GET", nbPath(siteSlug)),
  put: (siteSlug: string, body: NetbirdIn): Promise<ApiResponse<NetbirdConfig>> =>
    request<NetbirdConfig>("PUT", nbPath(siteSlug), body),
  remove: (siteSlug: string): Promise<ApiResponse<void>> =>
    request<void>("DELETE", nbPath(siteSlug)),
};
